module.exports = __webpack_public_path__ + "img/editar.7912edbe.svg";